module.exports = __webpack_public_path__ + "static/media/walter.88b56ee0.jpg";